import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { Card, CardBody, Row, Col } from "reactstrap";
import content from 'content.json';

function Faq() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFaq = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqItems = [
    {
      question: `Are you affiliated with ${content.application}?`,
      answer: `No, ${content.brandname} is not affiliated with ${content.application} in any way. This website is an independent add-on tool that provides enhanced insights into your ${content.application} ${content.entries}. It is completely independent and is by no means officially connected to or endorsed by ${content.application}.`
    },
    {
      question: "Why do I need to log in with Google?",
      answer: "We use Google login because it provides a secure and reliable way to authenticate users. This also allows us to avoid managing passwords, password resets, and other account maintenance tasks directly, as Google manages these for us."
    },
    {
      question: `Why did you create ${content.brandname}?`,
      answer: `I created ${content.brandname} to analyze my ${content.entries}. This feature gives me a clear picture of ${content.entries}, by showing the average values. I hope this app can help other users gain similar insights into their ${content.application} ${content.entries}!`
    },
    {
      question: "Can I request new features?",
      answer: `Yes! I'm always open to feedback and new feature ideas. You can request features or report any issues by visiting our GitHub issues page.`
    },
    {
      question: `How does ${content.brandname} handle my privacy?`,
      answer: `We take your privacy very seriously. We only collect essential information to provide our services, and all data handling follows strict guidelines. For full details, please refer to our Privacy Policy.`
    },
    {
      question: `Does ${content.brandname} use cookies?`,
      answer: `Yes, we use a functional cookie that stores your session login information for 3 hours. We do not use marketing or analytics cookies. For more information, please see our Cookie Policy.`
    }
  ];

  return (
    <div className="content">
      <Row>
        <Col md="10">
          <div style={{ padding: '0 8px' }}>
            <h1 style={{ fontSize: '1.8rem', marginBottom: '8px' }}>
              <i className="fas fa-question-circle" style={{ color: 'var(--airiq-teal)', marginRight: '12px' }}></i>
              Frequently Asked Questions
            </h1>
            <p style={{ marginBottom: '32px', color: 'var(--airiq-text-secondary)' }}>
              Find answers to common questions about {content.brandname}
            </p>

            {faqItems.map((item, index) => (
              <div className={`faq-item ${openIndex === index ? 'open' : ''}`} key={index}>
                <button className="faq-question" onClick={() => toggleFaq(index)}>
                  <span>{item.question}</span>
                  <i className={`fas fa-chevron-down faq-chevron`}></i>
                </button>
                <div className="faq-answer">
                  <p style={{ margin: 0 }}>{item.answer}</p>
                  {index === 3 && (
                    <p style={{ marginTop: '12px' }}>
                      Visit: <a href="https://github.com/stevedep/IndoorAirIQ/issues" target="_blank" rel="noopener noreferrer">
                        github.com/stevedep/IndoorAirIQ/issues
                      </a>
                    </p>
                  )}
                  {index === 4 && (
                    <p style={{ marginTop: '12px' }}>
                      <NavLink to="/admin/Privacy">View Privacy Policy →</NavLink>
                    </p>
                  )}
                  {index === 5 && (
                    <p style={{ marginTop: '12px' }}>
                      <NavLink to="/admin/Cookies">View Cookie Policy →</NavLink>
                    </p>
                  )}
                </div>
              </div>
            ))}

            {/* Action Buttons */}
            <div style={{ marginTop: '32px', display: 'flex', gap: '12px' }}>
              <NavLink to="/" className="btn-airiq" style={{ textDecoration: 'none', display: 'inline-block' }}>
                <i className="fas fa-home" style={{ marginRight: '8px' }}></i>Home
              </NavLink>
              <a href="mailto:steve.depeijper@gmail.com" className="btn-airiq-outline" style={{ textDecoration: 'none', display: 'inline-block' }}>
                <i className="fas fa-envelope" style={{ marginRight: '8px' }}></i>Contact Us
              </a>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default Faq;
